import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import _ from 'lodash'

import { hiddenHandler, hasDropdownBtn, rowInOpenRows, getAllChildrenRowsCodes, childrenAbove } from '../../helpers'

import { LOCALE_PREFIX as TOOLTIPS_PREFIX } from '../../../../constants'

import './style.scss'

export default class Body extends Component {
    static propTypes = {
        activeRowIndex: PropTypes.string,
        addOpenRow: PropTypes.func.isRequired,
        handleMouseLeaveRow: PropTypes.func.isRequired,
        handleRowHover: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isAdvanced: PropTypes.bool,
        openRows: PropTypes.array,
        removeOpenRows: PropTypes.func.isRequired,
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
        showRowTooltips: PropTypes.bool.isRequired,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            exportAsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsDropdownText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            emptySections: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    static defaultProps = {
        isAdvanced: false,
    }

    handleToggleOpenRow = (row, sectionRows) => {
        const { id, openRows, addOpenRow, removeOpenRows, tableType } = this.props
        const rowId = _.get(row, 'columnCode', null)

        if (_.find(openRows, (x) => x === rowId)) {
            const rowIdsToRemove = [rowId, ...getAllChildrenRowsCodes(rowId, sectionRows)]

            removeOpenRows(id, tableType, rowIdsToRemove, openRows)
            return null
        }

        addOpenRow(id, tableType, rowId, openRows)
        return null
    }

    render() {
        const {
            translates,
            activeRowIndex,
            sectionsDefinition,
            handleMouseLeaveRow,
            handleRowHover,
            showRowTooltips,
            openRows,
            id,
            isAdvanced,
            tableType,
        } = this.props

        if (_.isEmpty(sectionsDefinition)) {
            return (
                <div className={'empty-sections'}>
                    <span className={'empty-text'}>{translates.emptySections}</span>
                </div>
            )
        }

        return (
            <div className={'fixed-column-body-content'}>
                {_.map(sectionsDefinition, (section, sectionIndex) => (
                    <div key={`${section.typeCode}-section`} className={'fc-section'}>
                        <div className={'ft-row section-title'}>{_.get(section, 'title', '')}</div>
                        {_.map(
                            _.get(section, 'rows', []),
                            (row, index) =>
                                (!isAdvanced || (isAdvanced && !hiddenHandler(row, openRows))) && (
                                    <div
                                        key={`fc-${row.columnCode}-row`}
                                        onMouseOver={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        onMouseLeave={() => handleMouseLeaveRow()}
                                        onFocus={() => handleRowHover(`${sectionIndex}-${index}`)}
                                        className={classnames(
                                            'ft-row',
                                            row.highlight && 'sum-row',
                                            row.prefix && 'with-prefix',
                                            activeRowIndex === `${sectionIndex}-${index}` && 'active',
                                            `indentation-${_.get(row, 'indentationLevel', 0)}`
                                        )}
                                    >
                                        {isAdvanced && hasDropdownBtn(section, row) && (
                                            <div
                                                className={classnames(
                                                    'dropdown-btn',
                                                    rowInOpenRows(openRows, row) ? 'active' : null,
                                                    childrenAbove(_.get(section, 'rows', []), row) ? 'flipped' : null
                                                )}
                                                onClick={() =>
                                                    this.handleToggleOpenRow(row, _.get(section, 'rows', []))
                                                }
                                            />
                                        )}
                                        <span className={'fc-prefix'}>{_.get(row, 'prefix', '')}</span>
                                        <span className={'fc-title'}>{_.get(row, 'text', '')}</span>
                                        {_.get(row, 'configuration.unit') && (
                                            <span className={'fc-unit'}>
                                                {`[${_.get(
                                                    translates,
                                                    `units.${_.get(row, 'configuration.unit')}`,
                                                    ''
                                                )}]`}
                                            </span>
                                        )}
                                        {showRowTooltips && (
                                            <Tooltip
                                                id={`ft_tooltip_${id}_${sectionIndex}_${index}_${tableType}`}
                                                showDelay={250}
                                                content={
                                                    _.get(translates, `tooltips.${_.get(row, 'columnCode')}`) ? (
                                                        <FormattedMessage
                                                            id={`${TOOLTIPS_PREFIX}.tooltip.${_.get(
                                                                row,
                                                                'columnCode'
                                                            )}`}
                                                            values={{
                                                                br: <br />,
                                                                strong: (chunks) => (
                                                                    <strong style={{ color: 'hsl(0, 0, 20%)' }}>
                                                                        {chunks}
                                                                    </strong>
                                                                ),
                                                                table: (chunks) => (
                                                                    <table style={{ color: '#bed02e' }}>{chunks}</table>
                                                                ),
                                                                tr: (chunks) => <tr>{chunks}</tr>,
                                                                td: (chunks) => <td>{chunks}</td>,
                                                                div: (chunks) => <div>{chunks}</div>,
                                                                floatleft: (chunks) => (
                                                                    <div style={{ float: 'left' }}>{chunks}</div>
                                                                ),
                                                                divBorder: (chunks) => (
                                                                    <div
                                                                        style={{
                                                                            borderBottom: '1px solid',
                                                                            fontSize: 'small',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    >
                                                                        {chunks}
                                                                    </div>
                                                                ),
                                                                smallFont: (chunks) => (
                                                                    <div
                                                                        style={{
                                                                            fontSize: 'small',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    >
                                                                        {chunks}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    ) : (
                                                        'Missing tooltip'
                                                    )
                                                }
                                                position={POSITION.TOP}
                                                align={ALIGN.CENTER}
                                            >
                                                <div
                                                    className={classnames(
                                                        'tooltip-icon',
                                                        activeRowIndex === `${sectionIndex}-${index}` && 'active'
                                                    )}
                                                />
                                            </Tooltip>
                                        )}
                                    </div>
                                )
                        )}
                    </div>
                ))}
            </div>
        )
    }
}
